/**
 * Update profile factors API handler (registration flow)
 * PUT /customers/profile/factors
 * Uses baseurlv2
 */
import { baseurlv2HttpRequest } from '../../../../service';
export const updateProfileFactors = (payload, signal) => {
    return baseurlv2HttpRequest({
        url: '/customers/profile/factors',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: payload,
        signal,
    });
};
//# sourceMappingURL=updateProfileFactors.js.map